<div *ngIf='userSessionData' class='ContentListing'>
  <div class='ContentListing-header d-flex flex-row'>
    <div
      class='ContentListing-header-title flex-grow-1 d-flex flex-row align-items-center'>
      <div class='flex-grow-1 d-flex flex-row'>
        <h4>Content</h4>
        <app-svg-renderer
          (click)='onInfoImageClick()'
          [svg]="'Yellow Plane'"
          class='ms-1 mt-1 cursor-pointer'></app-svg-renderer>
      </div>
    </div>
  </div>
  <div class='ContentListing-body d-flex flex-column py-3'>
    <div
      *ngIf="userSessionData.user_type !== 'vsm'"
      class='ContentListing-body-item flex-grow-1 d-flex flex-row'>
      <div
        class='ContentListing-body-item-text flex-grow-1 d-flex flex-row align-items-center'>
        <fa-icon
          [icon]='iconQuestionCircle'
          [popoverAnimation]='true'
          [popoverDisabled]='false'
          [popoverOnHover]='true'
          [popoverPlacement]="'right'"
          [popover]='properties.content.tooltip'
          size='2x'></fa-icon>
        <h5>Content Group</h5>
      </div>
      <div class='ContentListing-body-item-button flex-grow-0'>
        <app-button
          [color]='buttonProperties.color'
          [route]='properties.content.url'
          [size]='buttonProperties.size'
          [style]='buttonProperties.style'
          [text]='buttonProperties.text'></app-button>
      </div>
    </div>
    <div
      *ngIf="
        userSessionData.user_type !== 'vsm' &&
        userSessionData.user_type !== 'manager' &&
        userSessionData.user_type !== 'partner'
      "
      class='ContentListing-body-item flex-grow-1 d-flex flex-row'>
      <div
        class='ContentListing-body-item-text flex-grow-1 d-flex flex-row align-items-center'>
        <fa-icon
          [icon]='iconQuestionCircle'
          [popoverAnimation]='true'
          [popoverDisabled]='false'
          [popoverOnHover]='true'
          [popoverPlacement]="'right'"
          [popover]='properties.response.tooltip'
          size='2x'></fa-icon>
        <h5>Response Group</h5>
      </div>
      <div class='ContentListing-body-item-button flex-grow-0'>
        <app-button
          *ngIf="canUserEdit()"
          [color]='buttonProperties.color'
          [route]='properties.response.url'
          [size]='buttonProperties.size'
          [style]='buttonProperties.style'
          [text]='buttonProperties.text'></app-button>
      </div>
    </div>
    <div
      *ngIf="userSessionData.user_type !== 'vsm'"
      class='ContentListing-body-item flex-grow-1 d-flex flex-row'>
      <div
        class='ContentListing-body-item-text flex-grow-1 d-flex flex-row align-items-center'>
        <fa-icon
          [icon]='iconQuestionCircle'
          [popoverAnimation]='true'
          [popoverDisabled]='false'
          [popoverOnHover]='true'
          [popoverPlacement]="'right'"
          [popover]='properties.signature.tooltip'
          size='2x'></fa-icon>
        <h5>Signature</h5>
      </div>
      <div class='ContentListing-body-item-button flex-grow-0'>
        <app-button
          [color]='buttonProperties.color'
          [route]='properties.signature.url'
          [size]='buttonProperties.size'
          [style]='buttonProperties.style'
          [text]='buttonProperties.text'></app-button>
      </div>
    </div>
    <div
      *ngIf="
        userSessionData.user_type !== 'vsm' &&
        userSessionData.user_type !== 'manager' &&
        userSessionData.user_type !== 'partner'
      "
      class='ContentListing-body-item flex-grow-1 d-flex flex-row'>
      <div
        class='ContentListing-body-item-text flex-grow-1 d-flex flex-row align-items-center'>
        <fa-icon
          [icon]='iconQuestionCircle'
          [popoverAnimation]='true'
          [popoverDisabled]='false'
          [popoverOnHover]='true'
          [popoverPlacement]="'right'"
          [popover]='properties.quick.tooltip'
          size='2x'></fa-icon>
        <h5>Quick Response</h5>
      </div>
      <div class='ContentListing-body-item-button flex-grow-0'>
        <app-button
          *ngIf="canUserEdit()"
          [color]='buttonProperties.color'
          [route]='properties.quick.url'
          [size]='buttonProperties.size'
          [style]='buttonProperties.style'
          [text]='buttonProperties.text'></app-button>
      </div>
    </div>
    <div
      *ngIf="
        userSessionData.user_type === 'master' ||
        userSessionData.user_type === 'vsm'
      "
      class='ContentListing-body-item flex-grow-1 d-flex flex-row'>
      <div class='ContentListing-body-item-text flex-grow-1 align-items-center'>
        <h5>Edge Quick Response</h5>
      </div>
      <div class='ContentListing-body-item-button flex-grow-0'>
        <app-button
          [color]='buttonProperties.color'
          [route]='properties.vsm.url'
          [size]='buttonProperties.size'
          [style]='buttonProperties.style'
          [text]='buttonProperties.text'></app-button>
      </div>
    </div>
  </div>
</div>
